import { render, staticRenderFns } from "./editQuestionAnswerList.vue?vue&type=template&id=17483366&scoped=true"
import script from "./editQuestionAnswerList.vue?vue&type=script&lang=js"
export * from "./editQuestionAnswerList.vue?vue&type=script&lang=js"
import style0 from "./editQuestionAnswerList.vue?vue&type=style&index=0&id=17483366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17483366",
  null
  
)

export default component.exports